/**
 * @bos/portal3 — the auth guard for the unauthenticated entry.
 *
 * <RedirectIfAuthed> wraps /login and /register: a logged-in user is bounced to the
 * dashboard so the sign-in forms are never shown to someone already signed in. The
 * protected pages are gated by <AppShell> itself (the single authenticated layout), so
 * they no longer each need a wrapper.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { PATHS } from '../routes';

export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'authenticated') return <Navigate to={PATHS.dashboard} replace />;
  return <>{children}</>;
}
